import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {firstNestedSymbolControl, WertelisteElement, Wertemenge} from '../../../models/uiArtefakt';
import {NgForm, NgModel} from '@angular/forms';
import {BehaviorSubject, Subscription} from 'rxjs';
import {ValidationService} from '../../../services/validation.service';
import {UiUpdateService} from '../../../services/ui-update.service';
import {WertemengenService} from '../../../services/wertemengen.service';
import {ErrorStateMatcherFormInput, inOutAnimation, ISymbol} from '@lv1871/core';
import {ErrorStateMatcher} from '@angular/material/core';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {EventService} from '../../../services/event.service';

@Component({
    selector: 'lv-search-multi',
    templateUrl: './search-multi.component.html',
    styleUrls: ['./search-multi.component.scss'],
    animations: [inOutAnimation],
    providers: [WertemengenService],
    standalone: false
})
export class SearchMultiComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(NgForm, {static: true})
  private _ngForm;

  @ViewChild('searchMulti', {static: true})
  private _searchValueField: NgModel;

  public filteredOptions$: BehaviorSubject<WertelisteElement[]>;
  public selectedItems: WertelisteElement[] = [];
  public model;
  public isDisabled: boolean = false;
  public stateMatcherFormInput: ErrorStateMatcher = new ErrorStateMatcherFormInput();
  public isSearching: boolean;
  public nestedSymbol: ISymbol;

  private _uiArtefakt: Wertemenge;
  private _subscription = Subscription.EMPTY;

  constructor(private _validationService: ValidationService,
              private _uiUpdateService: UiUpdateService,
              private _wertemengenService: WertemengenService,
              private _eventService: EventService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): Wertemenge {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: Wertemenge) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  ngOnInit(): void {
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
    if (!!this.uiArtefakt.WertEingabe) {
      this.selectedItems = this.uiArtefakt.WertEingabe;
    } else {
      this.uiArtefakt.WertEingabe = [];
      this.selectedItems = this.uiArtefakt.WertEingabe;
    }
    this.filteredOptions$ = this._wertemengenService.filteredOptions$;
    this._subscription = this.filteredOptions$.subscribe(_ => {
      this.isSearching = false;
    });
    this._filter('');
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public setValue(value: string) {
    const newValue = this.filteredOptions$.getValue().filter(wert => wert.WertAnzeige === value)[0];
    this.model = void 0;
    if (!!this.selectedItems.filter(item => item.WertAnzeige === newValue.WertAnzeige).length) {
      return;
    }
    this.uiArtefakt.WertEingabe.push(newValue);
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  public filterOptions(value: string) {
    this.model = value;
    this._filter(value);
  }

  public trackByFn(index, item) {
    return item.id;
  }

  public onDeleteItemClicked(element: WertelisteElement) {
    this.selectedItems = this.selectedItems.filter(item => element.WertEingabe !== item.WertEingabe);
    this.uiArtefakt.WertEingabe = this.selectedItems;
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  onBlur() {
    if(!!this._uiArtefakt.ReferenzIdentifikator){
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }

  private _filter(value: any) {
    this.isSearching = this._wertemengenService.filterWertemenge(this.uiArtefakt, value);
  }

}
